interface UserIdParams {
  userId: number;
}

export const newCommunityMembersPath = () => "/community_members/new";

export const resendInvitation = ({ userId }: UserIdParams) =>
  `/community_members/resend_invitation?user_id=${userId}`;
